import React from 'react'
import uuid from 'uuid/v1'

export default function MiniTestSection({ miniTestTitle, sectionContent }) {
   return (
      <div className='mini-test-section'>
         <h1>{miniTestTitle}</h1>
         <p>This is a Mini-Test Component portion</p>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/BookPrint/MiniTestSection.js